import { Alert, Box, Typography } from "@mui/material";
import { intl } from "LocaleWrapper";
import { GeneralEntityChangeFragment as EntityChange } from "__generated__/components/entityHistory/graphql/entityHistory.fragments.generated";
import ListRevisionChanges from "./changes/ListRevisionChanges";

const RevisionChanges = ({ changes }: {
	changes: EntityChange[];
}) => {
	if (changes.length === 0) {
		return (
			<Box display="flex" justifyContent="center" p={2}>
				<Alert severity="warning" sx={{ flexGrow: 1 }}>
					<Typography variant="body2" color="text.secondary">
						{intl.formatMessage({ id: "HISTORY_NO_CHANGES" })}
					</Typography>
				</Alert>
			</Box>
		);
	}

	return <ListRevisionChanges changes={changes} />;
};

export default RevisionChanges;
